import { motion } from "framer-motion";

const variants = {
  hidden:  { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0 },
};

/** Scroll-triggered fade-in-up element. */
export default function Reveal({ children, delay = 0, y = 28, className = "", as: As = "div" }) {
  const MotionAs = motion[As] || motion.div;
  return (
    <MotionAs
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={{
        hidden: { opacity: 0, y },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </MotionAs>
  );
}

export { variants };
